import { languageService } from "../../../../Language/language.service";

export const hosUsersTableSchema = [
  {
    Header: languageService("Name"),
    accessor: "name",
    id: "name",
    minWidth: 150,
  },
  {
    Header: languageService("Role"),
    accessor: "userRole",
    minWidth: 150,
  },
  {
    Header: languageService("Email"),
    accessor: "email",
    id: "email",
    minWidth: 150,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosUsers/schemas/hosUsersTableSchema.js